import * as React from 'react';
import {
  Box,
  Paper,
  Button,
  TextField,
  Typography
} from '@mui/material'

import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';

import SmartToyIcon from '@mui/icons-material/SmartToy';

import { login, getUser } from '../slices/auth';

const Login = (props) => {
  const [username, setUsername] = React.useState("");
  const [password, setPassword] = React.useState("");
  const navigate = useNavigate();
  const dispatch = useDispatch();

  React.useEffect(()=> {
    const role = localStorage.getItem("role")
    if(role === 'USER') navigate('/chat')
    else if(role === 'ADMIN' || role === 'SUPER_ADMIN') 
      navigate('/admin')
  }, [navigate]);

  const handleUsername = (e) => {
    setUsername(e.target.value);
  }

  const handlePassword = (e) => {
    setPassword(e.target.value);
  }

  const handleSubmit = (e) => {
    let formData = new FormData();
    formData.append('username', username);
    formData.append('password', password);
    dispatch(login(formData)).then(res => {
      const {type} = res.payload;
      dispatch(getUser());
      if(type === 'USER')
        navigate('/chat');
      else if(type === 'ADMIN' || type === 'SUPER_ADMIN')
        navigate('/admin');
    }).catch(err => console.log(err));
  }
  
  return (
    <Box className="w-full h-full bg-gray">
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          '& > :not(style)': {
            p: 4,
            width: 320,
          },
        }}
        className="h-full"
      >
        <Paper sx={{ p: 1}}>
          <Box sx={{display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 1, color: '#1878C6'}}>
            <SmartToyIcon sx={{width: 48, height: 48}}/>
            <Typography sx={{fontSize: 24, fontWeight: 600}}>Analytics Chat</Typography>
          </Box>
          <TextField
            required
            name="username"
            label="Email"
            sx={{mt: 4}}
            className='w-full'
            onChange={handleUsername}
          />

          <TextField
            required
            name="password"
            label="Password"
            sx={{mt: 2}}
            type='password'
            className='w-full'
            onChange={handlePassword}
          />

          <Button
            sx={{mt: 4, fontSize: 16, borderRadius: 8, textTransform: 'none', background: '#4F46E5'}}
            variant='contained'
            className='w-full'
            onClick={handleSubmit}
          >
            Sign in
          </Button>
        </Paper>
    </Box>
    </Box>
  )
}

export default Login;